// Shared phone-display helpers for the two onboarding handoff stages:
//   - the ONE door (src/marketing/components/messages-door)
//   - the surfaces that hand a signed-in visitor back to their own thread
//
// These format Ember's outbound number for display and build the SMS
// deep-link used by the "Open Messages" handoff CTA. (Phone-input
// helpers were removed when onboarding stopped collecting a phone
// number.)

export function formatPhone(e164: string): string {
  const us = /^\+1(\d{3})(\d{3})(\d{4})$/.exec(e164);
  if (us) return `+1 (${us[1]}) ${us[2]}-${us[3]}`;
  const cn = /^\+86(\d{3})(\d{4})(\d{4})$/.exec(e164);
  if (cn) return `+86 ${cn[1]} ${cn[2]} ${cn[3]}`;
  return e164;
}

// SMS deep-link for the handoff stage. iOS uses `&body=`; Android uses
// `?body=`. UA sniff is the only reliable cross-platform path here; the
// underlying sms: scheme is the same. Empty body → no pre-filled text,
// used by the returning-user handoff where the user already knows Ember.
export function buildSmsHref(toNumber: string, body: string): string {
  if (!body) return `sms:${toNumber}`;
  const ua = typeof navigator !== 'undefined' ? navigator.userAgent : '';
  const sep = /iPhone|iPad|iPod|Mac/i.test(ua) ? '&body=' : '?body=';
  return `sms:${toNumber}${sep}${encodeURIComponent(body)}`;
}
